import userSagas from './Users/saga';
import { all } from 'redux-saga/effects';

export default function* rootSaga() {
  yield all([userSagas()]);
}
